// prettier-ignore
export const GNB_FONT = 'https://fonts.googleapis.com/css?family=Noto+Sans+KR:400,500,700&display=swap&subset=korean';

export const CHANNELLING_LIST = [
  {
    type: 'bugs',
    adult: true,
    games: [
      '아바(A.V.A)',
      '슬러거',
      '뉴맞고',
      '맞고',
      '고스톱',
      '섯다',
      '7포커',
      '하이로우',
      '훌라',
      '뉴포커',
      '로우바둑이',
      '홀덤',
      '루미큐브',
      '바둑',
      '장기',
      '오목',
      '상하이플러스',
      '사천성플러스',
      '틀린그림찾기',
      '치코치코 더큐브'
    ]
  },
  {
    type: 'bugs',
    adult: false,
    games: [
      '아바(A.V.A)',
      '슬러거',
      '루미큐브',
      '바둑',
      '장기',
      '오목',
      '상하이플러스',
      '사천성플러스',
      '틀린그림찾기',
      '치코치코 더큐브'
    ]
  },
  {
    type: 'sayclub',
    adult: true,
    games: [
      '뉴맞고',
      '맞고',
      '고스톱',
      '섯다',
      '7포커',
      '하이로우',
      '훌라',
      '뉴포커',
      '홀덤',
      '로우바둑이',
      '루미큐브',
      '바둑',
      '장기',
      '오목',
      '상하이플러스',
      '사천성플러스',
      '틀린그림찾기',
      '치코치코 더큐브'
    ]
  },
  {
    type: 'sayclub',
    adult: false,
    games: [
      '루미큐브',
      '바둑',
      '장기',
      '오목',
      '상하이플러스',
      '사천성플러스',
      '틀린그림찾기',
      '치코치코 더큐브'
    ]
  }
];
